import getConfig from '../partners/getConfig';

import initializeForm from './initializeForm';
import resetForm from './resetForm';
import toggleModalProduct from './toggleModalProduct';

export default (financierId) => (dispatch) => {
    const { getInitialValues } = getConfig(financierId);
    const initialValues = getInitialValues();

    dispatch(resetForm());
    dispatch(initializeForm(initialValues));
    dispatch(toggleModalProduct(true));
};
